import { defineRecipe } from "@chakra-ui/react";

export const inputRecipe = defineRecipe({
  className: "chakra-input",
  base: {
    w: "100%",
    h: "3rem",
    textAlign: "start",
    borderRadius: "{radii.xl}",
    fontSize: "fontSizes.md",
    borderColor: "border.input.outline",
    bg: "bg.input.outline",
    color: "text.input.outline",
    _placeholder: { color: "text.input.outline" },
    _focus: { borderColor: "text.input.outline" },
    _hover: { borderColor: "text.input.outline" },
  },
  variants: {
    variant: {
      outline: {
        borderWidth: "2px",
        borderColor: "border.input.outline",
        fontSize: "input.fontSizes.md",
        color: "text.input.outline",
        bg: "bg.input.outline",
        p: 3,
        _placeholder: {
          color: "text.input.outlinePlaceholder",
          fontSize: "fontSizes.md",
          fontWeight: "fontWeights.normal",
        },
        _focus: { borderColor: "border.input.outlineFocus" },
        _hover: { borderColor: "border.input.outlineHover" },
        _icon: {
          _hover: {
            bg: "bg.input.outline",
          },
        },
        "--focus-ring-color": "border.input.outlineFocus",
      },

      search: {
        borderWidth: "2px",
        borderColor: "border.input.search",
        borderBottomColor: "border.input.searchBottom",
        borderRadius: "{radii.lg}",
        bg: "bg.input.search",
        color: "text.input.search",
        p: 3,
        _placeholder: {
          color: "text.input.searchPlaceholder",
          fontSize: "fontSizes.input.sm",
        },
        _focus: {
          borderColor: "border.input.search",
          borderBottomColor: "border.input.searchBottom",
        },
        _hover: {
          borderColor: "border.input.search",
          borderBottomColor: "border.input.searchBottom",
        },
      },
    },
  },

  defaultVariants: {
    variant: "outline",
  },
});
